import {useState, useEffect, useRef} from "react";
import {createPortal} from "react-dom";
import {useParams} from "react-router-dom";
import {Modal, Typography, Button} from 'antd';
import moment from "moment"
import GoogleMapReact from 'google-map-react';

import KanbanTitle from "../../modules/Kanban/KanbanTitle";
import MissionColumn from "./MissionColumn";
import MissionCard from "./MissionCard";

import {getById, updateById} from "../../shared/services/missions";
import {add} from "../../shared/services/earning";

import {statuses, statusList, positionStatus} from "./missionStatuses";

import styles from "./single-mission-page.module.scss";
import ClientCard from "../../modules/CLientCard";

import {ReactComponent as Logo} from "./logo.svg"

const kanbanRoot = document.getElementById("kanban-root")

const isArchive = ({archive_c, archive_d, archive_e}) => (archive_c + archive_d + archive_e) > 0;

const { Title } = Typography;

const MissionMarker = () => <div className={styles.missionMarker}></div>;

const SingleMissionPage = () => {
    const [mission, setMission] = useState(null);
    const [currentStatus, setCurrentStatus] = useState(null)
    const [modalOpen, setModalOpen] = useState(false);
    const [selectStatus, setSelectStatus] = useState(false);
    const [selectDelegate, setSelectDelegate] = useState(false)

    const {id} = useParams();

    const dragStartHandler = (e, card)=> {

    }

    const dragEndHandler = (e)=> {

    }

    const dragOverHandler = (e)=> {
        if (e.preventDefault) {
            e.preventDefault();
        }

        return false;
    }

    const dropHandler = (e, card)=> {
        e.preventDefault();
        const {id} = e.target;
        const index = Object.values(statuses).findIndex(item => item === id);
        if(index !== -1 && index !== 8) {
            setCurrentStatus(index);
        }
        if(index === 1) {
            setSelectDelegate(true)
        }
        if(index === 8) {
            setSelectStatus(true)
        }
    }

    useEffect(() => {
        const fetchMission = async () => {
            try {
                const data = await getById(id);
                setMission(data);
                setCurrentStatus(data.status);
            } catch (error) {
                console.log(error)
            }
        }
        fetchMission()
    }, []);

    const firstRender = useRef(true);

    const kanbanRef = useRef(null);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        const updateData = async () => {
            try {
                const newData = {status: currentStatus};
                if(currentStatus === 0) {
                    newData.did = 0;
                }
                if(currentStatus === 9) {
                    newData.status = mission.status;
                    newData.archive_e = 1;
                } else {
                    newData.archive_e = 0;
                }

                const result = await updateById(mission.id, newData);
                setMission(prevSate => ({...prevSate, ...newData}));
                if(currentStatus === 9) {
                    setCurrentStatus(mission.status)
                }
                if(currentStatus === 7) {
                    const {did: uid, id: mid, expected_hours} = mission;
                    const date = moment().format("YYYY-MM-DD");
                    const time = moment().format("hh:mm:ss")
                    const data = {
                        uid,
                        mid,
                        price: Number(expected_hours) * 20 + 50,
                        status: 0,
                        date,
                        time,
                    }
                    const result = await add(data);
                    console.log(result)
                }
            }
            catch(error){
                setCurrentStatus(mission.status)
            }
        };

        if(kanbanRef.current) {
           const position = isArchive(mission) ? 7 : positionStatus[currentStatus];
            if(position > 1) {
                const firstColumn = kanbanRef.current.firstElementChild;
                const columnWidth = firstColumn?.getBoundingClientRect().width || 395;
                const styles = window.getComputedStyle(kanbanRef.current);
                const gap = Number.parseFloat(styles.columnGap || styles.gap) || 24;
                const left = (position - 1) * (columnWidth + gap);

                kanbanRef.current.scrollTo({left, behavior: "smooth"});
                kanbanRef.current = null;
            }

        }
        if(mission.status !== currentStatus) {
            updateData();
        }

    }, [currentStatus]);

    if (!mission) {
        return createPortal(
            (
                <div className={styles.wrapper}>
                    <KanbanTitle/>
                </div>
            ),
            kanbanRoot
        )
    }
    const {mission_title} = mission;
    const statusName = isArchive(mission) ? statuses[9] : statuses[currentStatus];

    const kanbanElements = statusList.map((status, index) => {

        let missionStatus = "";
        if (index !== 5) {
            missionStatus = status;
        }
        if(index === 5) {
            missionStatus = currentStatus === 7 ? "Client confirms mission completed successfully" : "Client confirms mission is not completed";
        }
        const data = (statusName === missionStatus) ? mission : null;
        if(data) {
            return (<MissionColumn key={index} status={missionStatus}>
                <MissionCard setStatus={setCurrentStatus} showInvoice={()=> setModalOpen(true)} dragStartHandler={dragStartHandler} dragEndHandler={dragEndHandler} dragOverHandler={dragOverHandler} dropHandler={dropHandler} id={id} {...data} />
            </MissionColumn>)
        }
        else {
            return <MissionColumn  key={index} status={missionStatus} drag={{dragStartHandler, dragEndHandler, dragOverHandler, dropHandler}} />
        }
    })

    const totalCost = Number(mission.expected_hours) * 50 + 50

    const setModalChangeStatus = (status) => {
        setCurrentStatus(status);
        setSelectStatus(false)
    }

    const defaultProps = {
        center: {
            lat: Number(mission.address_lat),
            lng: Number(mission.address_lng)
        },
        zoom: 11
    };

    return createPortal(
        (
            <div className={styles.wrapper}>
                <KanbanTitle title={mission_title} />
                <div ref={kanbanRef} className={styles.kanban}>
                    {kanbanElements}
                </div>
                <Modal width={700} open={modalOpen} onCancel={() => setModalOpen(false)} footer={null}>
                    <div className={styles.invoice}>
                        <h4 className={styles.invoiceTitle}>
                            <span>Invoice</span>
                            <Logo />
                        </h4>
                        <div className={styles.invoiceCompanyInfo}>
                            <div>
                                <p className={styles.invoiceCompanyInfoText}>Bthere DWC-LLC</p>
                                <p className={styles.invoiceCompanyInfoText}>Dubai South - Bldg A5 - office 244D</p>
                                <p className={styles.invoiceCompanyInfoText}>PO box: 713065 - License 9076 - TRN</p>
                                <p className={styles.invoiceCompanyInfoText}>100470139500003</p>
                            </div>
                            <div>
                                <p className={styles.invoiceCompanyInfoText}>GSM & WhatsApp</p>
                                <p className={styles.invoiceCompanyInfoText}>+971 58 531 5444</p>
                                <p className={styles.invoiceCompanyInfoText}>info@bthere.xyz</p>
                            </div>
                        </div>

                        <div className={styles.invoiceInfo}>
                            <p>Mission name: {mission?.mission_title}</p>
                            <p>Mission date: {moment(mission?.date).format("MMMM Do YYYY")}</p>
                        </div>
                        <div className={styles.invoiceInfo}>
                            <p>Client: {`${mission?.user?.first_name} ${mission?.user?.last_name}`}</p>
                            <p>Delegate: {`${mission?.delegate?.first_name} ${mission?.delegate?.last_name}`}</p>
                        </div>

                        <div className={styles.invoiceSeparate}></div>

                        <p className={styles.invoiceDetailsTitle}>Invoice details</p>

                        <p className={styles.invoiceDetails}>
                            <span>1. Bthere delegate misson fee</span>
                            <span>{mission.expected_hours} {mission.expected_hours > 1 ? "hours": "hour"} @ $50/hr</span>
                            <span>=</span>
                            <span style={{textAlign: "right"}}>$ {Number(mission.expected_hours) * 50}</span>
                        </p>

                        <p className={styles.invoiceDetails}>
                            <span>2. Bthere delegate travel and data allotment</span>
                            <span>$50</span>
                            <span>=</span>
                            <span style={{textAlign: "right"}}>$ 50</span>
                        </p>

                        <p className={styles.invoiceDetails}>
                            <span>3. Bthere delegate additional expenses</span>
                            <span>$ only if they exist</span>
                            <span>=</span>
                            <span style={{textAlign: "right"}}>$ {Number(mission.expenses_transport) + Number(mission.expenses_data)}</span>
                        </p>

                        <div className={styles.invoiceSeparate}></div>

                        <div className={styles.invoiceTotal}>
                            <span></span>  TOTAL <span>{totalCost}</span>
                        </div>

                        <p className={styles.invoiceURL}>Mission URL: https://bthere.xyz/client/missions/{id}/</p>

                        <p>Bthere <br />
                            Travel Less. Archive More.</p>

                        <div className={styles.invoiceSeparate}></div>

                        <p className={styles.invoiceTransactionTitle}>Stripe Transaction ID</p>

                        <p className={styles.invoiceTransactionNumber}>{mission.payment_intent_id}</p>

                        {/*<p className={styles.invoiceTransactionLink}>Link to stripe receipt - </p>*/}
                    </div>


                </Modal>
                <Modal open={selectStatus} onCancel={() => setSelectStatus(false)} footer={null}>
                    <Title level={3} style={{textAlign: "center"}}>Select mission complete status</Title>
                    <div className={styles.statusActions}>
                        <Button type="default" onClick={()=> setModalChangeStatus(7)} style={{borderRadius: "4px", cursor: "pointer", color: "#52c41a", borderColor: "#52c41a"}}>
                            Mission completed
                        </Button>

                        <Button type="default" onClick={()=> setModalChangeStatus(8)} danger style={{borderRadius: "4px", cursor: "pointer"}}>
                            Mission not completed
                        </Button>

                        <Button type="default" onClick={()=> setSelectStatus(false)} style={{borderRadius: "4px", cursor: "pointer"}}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
                {mission.address_lng && mission.address_lng && <Modal width={700} open={selectDelegate} onCancel={() => setSelectDelegate(false)} footer={null}>
                    <Title level={3} style={{textAlign: "center"}}>Select mission candidate</Title>
                    <div className={styles.mapContainer}>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "AIzaSyDgVzPOINwOlVxm5qR1heijzg06XVmbeu0" }}
                            defaultCenter={defaultProps.center}
                            defaultZoom={defaultProps.zoom}>
                            <MissionMarker lat={mission.address_lat} lng={mission.address_lng} />
                        </GoogleMapReact>
                    </div>
                
                </Modal>}
            </div>
        ),
        kanbanRoot
    )
}

export default SingleMissionPage;
